module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KE-72cc50be48ece5a027ee9a41224d0099.png";